import { render, staticRenderFns } from "./BusinessCardEditor.vue?vue&type=template&id=13e4a65e"
import script from "./BusinessCardEditor.vue?vue&type=script&lang=js"
export * from "./BusinessCardEditor.vue?vue&type=script&lang=js"
import style0 from "./BusinessCardEditor.vue?vue&type=style&index=0&id=13e4a65e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports